import { request } from 'apis/lib/request_cms';
import Settings from 'settings';

//导航内容查询
export function contentFindByPagination(params) {
    return request({
        url: '/mwebapi/cms/navigate2/findContentByPagination',
        method: 'GET',
        params,
    });
}
// 新增导航
export function contentAdd(params, logObj) {
    return request({
        url: '/mwebapi/cms/navigate2/addContent',
        method: 'POST',
        params,
        logObj,
        logFlag: {
            appName: '导航管理',
            operModule: '添加导航',
        },
    });
}
// 删除单条导航
export function contentDetele(params, logObj) {
    return request({
        url: '/mwebapi/cms/navigate2/deleteContent',
        method: 'GET',
        params,
        logObj,
        logFlag: {
            appName: '导航管理',
            operModule: '删除导航',
        },
    });
}
//修改导航
export function contentUpdate(params, logObj) {
    return request({
        url: '/mwebapi/cms/navigate2/updateContent',
        method: 'GET',
        params,
        logObj,
        logFlag: {
            appName: '导航管理',
            operModule: '编辑导航',
        },
    });
}
// 单条内容查询
export function contentGetDetail(params) {
    return request({
        url: '/mwebapi/cms/navigate2/getContentDetail',
        method: 'GET',
        params,
    });
}

// 栏目内容查询
export function columnContentGetDetail(params) {
    return request({
        url: '/mwebapi/cms/navigateColumn2/getContentDetail',
        method: 'GET',
        params,
    });
}

//新增栏目
export function columnContentAdd(data, logObj) {
    return request({
        url: '/mwebapi/cms/navigateColumn2/addContent',
        method: 'POST',
        data,
        logObj,
        logFlag: {
            appName: '导航管理',
            operModule: '添加导航栏目',
        },
    });
}
//栏目内容列表查询
export function columnContentFindByPagination(params) {
    return request({
        url: '/mwebapi/cms/navigateColumn2/findNavigateElementList',
        method: 'GET',
        params,
    });
}

// 删除对应导航栏目
export function columnContentDelete(params, logObj) {
    return request({
        url: '/mwebapi/cms/navigateColumn2/deleteContent',
        method: 'GET',
        params,
        logObj,
        logFlag: {
            appName: '导航管理',
            operModule: '删除导航栏目',
        },
    });
}
// 修改栏目
export function columnContentUpdate(data, params, logObj) {
    return request({
        url: '/mwebapi/cms/navigateColumn2/updateContent',
        method: 'POST',
        data,
        params,
        logObj,
        logFlag: {
            appName: '导航管理',
            operModule: '编辑导航栏目',
        },
    });
}
export function columnUpdateStatus(params) {
    return request({
        url: '/mwebapi/cms/navigateColumn2/updateStatus',
        method: 'get',
        params,
    });
}

// 移动栏目
export function columnMove(data) {
    return request({
        url: '/mwebapi/cms/navigateColumn2/updateForColumnMove',
        method: 'POST',
        data,
    });
}
//拖拽
export function dragAndDropSort(params) {
    return request({
        url: '/mwebapi/cms/navigateColumn2/dragAndDropSort',
        method: 'get',
        params,
    });
}
export function refreshData(params) {
    return request({
        url: '/mwebapi/cms/navigateColumn2/refreshData',
        method: 'get',
        params,
    });
}

//动态获取链接地址
export function getDynamicLinkAddress(data, params) {
    return request({
        url: '/mwebapi/lowcode/content/getDynamicLinkAddress',
        method: 'post',
        data,
        params,
    });
}

export function getAppList(params) {
    return request({
        method: 'get',
        dataType: 'form',
        params,
        url: `/mwebapi/lowcode/app/getAppList`,
    });
}

export function getAppListForRss() {
    return request({
        method: 'get',
        dataType: 'form',
        url: `/mwebapi/lowcode/app/getAppListForRss`,
    });
}
export function getAppSourceList(params) {
    return request({
        method: 'get',
        dataType: 'form',
        url: `/mwebapi/lowcode/app/getAppSourceList`,
        params,
    });
}
//上移下移
export function updateSort(data) {
    return request({
        method: 'post',
        data,
        url: '/mwebapi/cms/navigateColumn2/updateSort',
    });
}
// 校验导航条数是否超限接口
export function hasOverRun(params) {
    return request({
        method: 'post',
        url: `/mwebapi/cms/navigateColumn2/hasOverRun`,
        params,
    });
}


// yidaba获取token
export function token300(data) {
    return request({
        method: 'post',
        url: `/api/trade/token300.php`,
        data,
        dataType:'form',
        baseURL: Settings.present.yidaba,
    });
}